export default {
  // SNS用メッセージ
  SNS_MESSAGE: 'sns_message',

  APPLY_MESSAGE: '申請が完了しました', // 申請完了のメッセージ
  CANCEL_MESSAGE: '取消が完了しました', // 取消完了のメッセージ
  APPROVAL_MESSAGE: '承認が完了しました', // 承認完了のメッセージ
  REJECTION_MESSAGE: '差戻が完了しました', // 差戻完了のメッセージ

  ERROR_MESSAGE_APPLY: '申請する提出物を選択してください。',

  ERROR_MESSAGE_APPLY_CANCEL: '申請を取消する提出物を選択してください。',

  ERROR_MESSAGE_APPROVAL: '承認する提出物を選択してください。',

  ERROR_MESSAGE_REJECTION: '差戻する提出物を選択してください。',

  ERROR_MESSAGE_REJECT_REASON: '差戻の場合は却下時のコメントを入力してください。',

  ERROR_MESSAGE_APPLY_ALREADY: '選択した提出物に、申請済み(承認待ち)ステータスの提出物があるため申請ができません。',

  ERROR_MESSAGE_APPLY_CANCEL_ALREADY: '選択した提出物に、未申請または差戻ステータスの提出物があるため取消ができません。',
  
  // 各申請書や精算書への状態メッセージ
  ERROR_UPDATE_MESSAGE_PENDING: '※承認待ちのため更新ができません。' ,
  ERROR_UPDATE_MESSAGE_APPROVAL: '※承認済みのため更新ができません。'
}
